/* eslint-disable */
import React from "react";
import { Box, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import { setIsLogOutModalOpen } from "../../../services/store/slice/NotificationSlice";
import SignoutModal from "./SignoutModal";
function Logout() {
  const dispatch = useDispatch();
  const { isLogOutModalOpen } = useSelector((state) => state.notification);
  return (
    <>
      <Tooltip title="Logout" arrow placement="right-start">
        <Box
          sx={{
            p: 1,
            cursor: "pointer",
            "&:hover": {
              borderRadius: "7px",

              background: "#0D4273",
            },
            "&.active": {
              // backgroundColor: "#1b2631",
              background: "#085F99",
              borderRadius: "7px",
              // justifyContent: "center",
              // alignItems: "center",
              // display: "flex ",
              pt: "4px",
            },
          }}
        >
          <LogoutIcon
            fontSize="small"
            onClick={() => {
              dispatch(setIsLogOutModalOpen(true));
            }}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex ",
              color: "white",
            }}
          />
        </Box>
      </Tooltip>
      {isLogOutModalOpen && <SignoutModal />}
    </>
  );
}
export default Logout;
